import { Injector, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NguCarousel,
    NguCarouselDefDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguItemComponent,
    NguTileComponent } from '@ngu/carousel';
import { ReplaceTokensPipeArrayModule, SafePipeModule } from '@signature-it/ngx-generic/pipes';
import { ContentloaderModule } from '@signature-it/ngx-generic/components/contentloader';
import { FamilyCardModule_Catalogue, ProductCardModule_Catalogue } from '@signature-it/ngx-catalogue/components/catalog/products-cards';
import { ProductsCarouselComponent_Generic } from './products-carousel';
import { createCustomElement } from "@angular/elements";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ContentloaderModule,
        NguCarousel,
        NguCarouselDefDirective,
        NguCarouselNextDirective,
        NguCarouselPrevDirective,
        NguItemComponent,
        NguTileComponent,
        ProductCardModule_Catalogue,
        FamilyCardModule_Catalogue,
        ReplaceTokensPipeArrayModule,
        SafePipeModule
    ],
    declarations: [ProductsCarouselComponent_Generic],
    exports: [ProductsCarouselComponent_Generic]
})
export class ProductsCarouselModule_Generic {
     constructor(private injector: Injector) {
        const productsCarousel = createCustomElement(ProductsCarouselComponent_Generic, {injector});
        !customElements.get('ngx-products-carousel') && customElements.define('ngx-products-carousel', productsCarousel);
     }
}
